'use client'

import Link from 'next/link'

import { Category } from 'modules/Category/model/types'

import { Image } from 'shared/ui'

import { RouterPath } from 'shared/config/routerPath/RouterPath'

import styles from './CategoryCard.module.scss'

interface CategoryLinkCardProps {
  slug?: Category['slug']
  title: Category['name']
  image: Category['main_page_image']
  isDiscount?: boolean
  type?: 'desktop' | 'mobile'
}

export function CategoryCard({
  slug,
  image,
  title,
  isDiscount = false,
  type = 'desktop',
}: CategoryLinkCardProps) {
  const link = isDiscount
    ? `${RouterPath.CATALOG}/?discounted=true`
    : `${RouterPath.CATEGORY}/${type === 'desktop' ? `?categoryId=${slug}` : slug}`

  return (
    <div className={styles.card}>
      <Link href={link} prefetch={false} className={styles.link} />
      <h4 className={styles.title}>{title}</h4>
      {image && (
        <div className={styles.imageWrapper}>
          <Image
            className={styles.image}
            fetchPriority="high"
            src={image || ''}
            alt="icon"
            width={100}
            height={100}
          />
        </div>
      )}
    </div>
  )
}
